<template>
  <el-checkbox-group v-model="valueArr">
    <el-checkbox v-for=" item in list" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
  </el-checkbox-group>
</template>
<script>
export default {
  name: 'XrCheckbox',
  props: ['list', 'value'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      valueArr: []
    }
  },
  watch: {
    value(newValue) {
      this.valueArr = this.CommonUtils.strToArray(newValue);
    },
    list: {
      handler() {
        this.valueArr = this.CommonUtils.strToArray(this.value);
      },
      deep: true
    },
    valueArr(arr){
      let newValue = this.CommonUtils.createListCheckboxValue(arr);
      this.$emit('change', newValue);
    }
  },
  created() {
    this.$nextTick(()=>{
      this.valueArr = this.CommonUtils.strToArray(this.value);
    })
  },
  methods: {
    selectedChange(){
    }
  }
}
</script>

<style lang="scss" scoped>
  /** 按钮样式 */
  .th-button{
    display: inline;
    border: 1px solid #d9d9d9;
    padding: 4px 10px;
    border-radius: 5px;
    font-size: 12px;
    cursor: pointer;
    color: rgba(0,0,0,.65);
    margin-right: 8px;
  }

  .primary{
    background: #007aff;
    color: #fff;
  }



</style>



// WEBPACK FOOTER //
// src/components/XrCheckbox/index.vue